import { MotionLoader } from "@/components/custom/motion-loader.tsx";

/**
 * A route's `pendingComponent` when the route renders inside a shell that
 * stays on screen - the settings pane, the app's page container.
 *
 * The router shows a route's pending component while its loader runs past
 * `pendingMs` and while its component suspends on a query, and falls back to
 * `defaultPendingComponent`: the full-screen app loader, which covers the
 * sidebar and the pane header for what is only this route's wait. This draws
 * the loader where the route's content goes instead.
 */
export function RoutePending() {
	return <MotionLoader containerClassName="py-16" />;
}
